import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { APPLICATION_ROUTES } from 'constants/routes';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { canAccessPoSoTracking } from 'shared/utils/poSoTrackingAccess';
import { GuardProps } from 'types';

// ==============================|| PO & SO TRACKING GUARD ||============================== //

/**
 * Restricts PO & SO Tracking to a hardcoded email allowlist.
 */
const PoSoTrackingGuard = ({ children }: GuardProps) => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const allowed = canAccessPoSoTracking(currentUser?.sub);

    useEffect(() => {
        if (!allowed) {
            navigate(APPLICATION_ROUTES.franchisePartners.list, { replace: true });
        }
    }, [allowed, navigate]);

    if (!allowed) {
        return null;
    }

    return children;
};

export default PoSoTrackingGuard;
